import { createAction } from 'redux-actions'

export const SET_MODAL = createAction('SET_MODAL')
export const CLEAR_MODAL = createAction('CLEAR_MODAL')

export const setModal = (name, data) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(SET_MODAL({name, data}))
      resolve()
    })
  }
}

export const clearModal = () => {
  return (dispatch) => {
    dispatch(CLEAR_MODAL())
  }
}



// WEBPACK FOOTER //
// ./src/actions/modal.js